<template>
	<div>

		<!-- 添加切换按钮 -->
		<div style="margin-bottom: 10px; text-align: left;">
			<button @click="switchModal(0)" :class="['modal-button', {active: modal === 0}]" style="margin-right: 10px;">正常K</button>
			<button @click="switchModal(20)" :class="['modal-button', {active: modal === 20}]">敏感K</button>
		</div>

		<v-chart class="chart-day-timing" :options="line" @datazoom='onDataZoom($event,line)'/>
		<div>感谢<a href="/contact">捐赠</a>服务器费用</div>

		<!-- <div>{{line}}</div> -->
	</div>

</template>

<script>
	import ECharts from 'vue-echarts'

import Moment from 'moment'
import {
    request_zzquant, request_zrx
} from "network/request.js"
	let dataZoomData = {
		"start": 50,
		"end": 100
	}

	export default {
		props: {
			title: {
				type: String,
				default: "市场情绪周期"
			},
			subText: {
				type: String,
				default: "题材周期"
			}
		},
    components: {
        'v-chart': ECharts
    },
    mounted() {
        const c = localStorage.getItem('site.colorblind');
        if(c){ this.colorblind = (c==='1' || c==='true') }
        window.addEventListener('site-colorblind-changed', this.onColorblindChanged)
        this.refresh();
    },
    beforeDestroy(){ window.removeEventListener('site-colorblind-changed', this.onColorblindChanged) },
    data() {
        return {
            modal: 0, // 添加modal属性，
            colorblind: false,
            line: {
                title: {
                    text: this.title,
                    subtext: this.subText,
                    left: 0
                },
                color: [],
                legend: {
                    data: ["K", '最高板', '涨停板','跌停板', '封板率'],
                },
					grid: [
						{
							left: '5%',
							right: '5%',
							height: '30%',
							top: '5%'
						},
						{
							left: '5%',
							right: '5%',
							height: '30%',
							top: '35%' //从这里开始显示
						},
						{
							left: '5%',
							right: '5%',
							top: '65%', //从这里开始显示
							height: '20%'
						},
						{
							left: '5%',
							right: '5%',
							top: '85%',
							height: '10%'
						}
					],
					xAxis: [
					{
						type: 'category',
						data: [],
						scale: true,
						boundaryGap: false,
						axisLine: { onZero: false },
						splitLine: { show: false },
						splitNumber: 10,
						min: 'dataMin',
						max: 'dataMax',
						axisPointer: { z: 100 },
						axisLabel: { fontSize: 10 },
					},
					{
							gridIndex: 1,
							type: 'category',
							scale: true,
							axisLine: { onZero: false },
							splitLine: { show: false },
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: { z: 100 },
							axisLabel: { fontSize: 10, show: false },
						},
					{
						gridIndex: 2,
						type: 'category',
						axisLabel: { show: false }
					},
					{
						gridIndex: 3,
						type: 'category',
						// axisLabel: { show: false }
					},
					],
					yAxis: [
					
					{
						gridIndex: 0,
						scale: true,
						splitNumber: 2,
						axisLine: { lineStyle: { color: '#8392A5' } },
						splitLine: { show: false },
						axisLabel: { show: false }
					},{
						gridIndex: 1,
							name: "最高板",
							scale: true,
							position: 'right',
							min: 0,
							max: 12,
							splitNumber: 10,
							splitLine: { show: true },
							splitArea: { show: true },
							axisLabel: {
								interval: 0,
								formatter: '{value}'
							},
						}, {
							name: "涨停",
							gridIndex: 2,
							scale: true,
							position: 'right',
							min: -100,
							max: 150,
							splitNumber: 10,
							splitLine: {
								show: false
							},
							splitArea: {
								show: true
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}'
							},
						}, {
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: '#DCDCDC',
									width: 1
								}
							},
							splitLine: false,
							position: 'left',
						},
						{
							name: "封板率",
							gridIndex: 3,
							scale: true,
							position: 'left',
							min: 0,
							max: 100,
							splitNumber: 5,
							splitLine: {
								show: true
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}%'
							}
						}
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	// xAxisIndex: [0, 1],
						// 	start: dataZoomData.start,
						// 	end: dataZoomData.end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1, 2, 3],
							y: '90%',
							start: dataZoomData.start,
							end: dataZoomData.end
						}
					],
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							// console.log(params)
							var h = params[0].name + " <br />";
							params.forEach((item) => {
								var v = 0;
								if (item.seriesName == '涨停板') {
									// v = (this.value*100).toFixed(0);
									v = item.value[1];
								} else if (item.seriesName == '跌停板') {
									v = item.value[1];
								}else if (item.seriesName == 'K') {
									// console.log(item)
									let close = item.value[2];
									let pre_close = item.value[5];
									let changePercent = ((close - pre_close) / pre_close * 100).toFixed(2);
									v = '<span> 涨幅:' + changePercent + '%'+'</span><br/><span>收盘:'+close+'</span>';
								} else {
									v = item.value
								}
								if (item.seriesName == '三连板') {
									h += " <br />";
								} else {
									h += item.seriesName + ":" + v + " <br />";
								}
							});
							return h;
						}
					},
					// 提示联动
                axisPointer: {
                    link: {xAxisIndex: 'all'},
                    // label: {
                    // 	backgroundColor: '#777'
                    // }
                },
            }
        }
    },
    methods: {
        onColorblindChanged(e){ const v = e && e.detail && typeof e.detail.colorblind!== 'undefined' ? !!e.detail.colorblind : (localStorage.getItem('site.colorblind')==='1' || localStorage.getItem('site.colorblind')==='true'); this.colorblind = v; this.refresh() },
        splitData(rawData) {
				let [categoryData,max_lb_num,lb_3_num,uplimit_num,downlimit_num,max_lb_stocks,damian_num,second_lb_num,fb_num,mian_num,bigleg_num ]= [[],[],[],[],[],[],[],[],[],[],[]];
				let [uplimit_num_m,downlimit_num_m ]= [[],[]];
				let [mark_line_mon, mark_line_day1] = [[],[]];
				let pre_month = -1;
				for (var i = 0; i < rawData.length; i++) {
					let item_date = rawData[i]['date1'];
					categoryData.push(rawData[i]['date1']);
					max_lb_num.push(rawData[i]['max_lb_num']);
					second_lb_num.push(rawData[i]['second_lb_num']);
					lb_3_num.push(rawData[i]['lb_3_num']);
					max_lb_stocks.push(rawData[i]['max_lb_stocks']);
					damian_num.push(rawData[i]['damian_num']);
					fb_num.push(rawData[i]['fb_num']);
					mian_num.push(rawData[i]['mian_num']);
					bigleg_num.push(rawData[i]['bigleg_num']);

					uplimit_num.push(rawData[i]['uplimit_num']);
					downlimit_num.push(rawData[i]['downlimit_num']);
					var uplimit = rawData[i]['uplimit_num']
					// uplimit = uplimit > 100 ? 100 : uplimit;
					uplimit_num_m.push([rawData[i]['date1'], uplimit, 1]);
					var downlimit = rawData[i]['downlimit_num'];
					// downlimit = downlimit > 100 ? 100 : downlimit;
					downlimit_num_m.push([rawData[i]['date1'], -downlimit, 1]);
					
					// 计算周一
					if(Moment(item_date).weekday()==1){
						mark_line_mon.push({
							xAxis:item_date,
							label: {formatter: item_date.substr(8)},
							})
					}
					if(Moment(item_date).month()!=pre_month){
						mark_line_day1.push({
							name:"月初", 
							label: {formatter: item_date.substr(5)},
							xAxis:item_date,
							})
						pre_month = Moment(item_date).month()
					}
				}
				return {
					categoryData: categoryData,
					max_lb_num: max_lb_num,
					second_lb_num: second_lb_num,
					lb_3_num: lb_3_num,
					uplimit_num: uplimit_num,
					downlimit_num: downlimit_num,
					downlimit_num_m: downlimit_num_m,
					uplimit_num_m: uplimit_num_m,
					max_lb_stocks: max_lb_stocks,
					damian_num: damian_num,
					fb_num: fb_num,
					mian_num: mian_num,
					bigleg_num: bigleg_num,
					mark_line_mon:mark_line_mon,
					mark_line_day1:mark_line_day1,
				};
			},
			splitKlineData(rawData) {
				let categoryData = [];
				let values = [];
				let p_close_pre1d = [];
				let iceData = [];
				let mark_line_mon = [];
				let mark_line_day1 = [];
				let pre_month = -1
				for (let i = 0; i < rawData.length; i++) {
					let item = rawData[i];
					let item_date = item['date']
					categoryData.push(item_date);
					values.push([item['p_open'], item['p_close'], item['p_high'], item['p_low'], item['p_close_pre1d']]);
					p_close_pre1d.push(item['p_close_pre1d'])
					// 处理冰点数据
					if (i > 0) {
						const prevClose = item['p_close_pre1d'];
						const currClose = item['p_close'];
						const changePercent = ((currClose - prevClose) / prevClose * 100).toFixed(2);
						
						if (parseFloat(changePercent) <= -2) {
							iceData.push({
								name: 'Ice',
								value: changePercent,
								xAxis: i,
								yAxis: currClose
							});
						}
					}
					
					// 计算周一
					if(Moment(item_date).weekday()==1){
						mark_line_mon.push({
							xAxis:item_date,
							label: {formatter: item_date.substr(8)},
							})
					}
					if(Moment(item_date).month()!=pre_month){
						mark_line_day1.push({
							name:"月初", 
							label: {formatter: item_date.substr(5)},
							xAxis:item_date})
						pre_month = Moment(item_date).month()
					}
				}
				
				return {
					categoryData: categoryData,
					values: values,
					iceData: iceData,
					mark_line_mon: mark_line_mon,
					mark_line_day1: mark_line_day1
				};
			},
			splitZhabanData(rawData) {
				var categoryData = [], zb_pct = [], num_lb=[];
				
				for (var i = 0; i < rawData.length; i++) {
					categoryData.push(rawData[i]['date1']);
					zb_pct.push((rawData[i]['uplimit_n_num'] / (rawData[i]['zb_num'] + rawData[i]['uplimit_n_num']) * 100).toFixed(2))
					num_lb.push(rawData[i]['uplimit_n_num'])
				}
				
				return {
					categoryData: categoryData,
					zb_pct: zb_pct,
					num_lb:num_lb,
				};
			},
			calculateMAForKline(dayCount, data) {
				let result = [];
				for (let i = 0, len = data.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					let sum = 0;
					for (let j = 0; j < dayCount; j++) {
						sum += data[i - j][1]; // 使用收盘价
					}
					result.push(+(sum / dayCount).toFixed(3));
				}
				return result;
			},
			calculateMA(dayCount, data) {
				var result = [];
				for (var i = 0, len = data.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += data[i - j][1];
					}
					result.push(+(sum / dayCount).toFixed(2));
				}
				return result;
			},
			get_mark_point_data(data) {
				var point_data = [];
				for (var i = 0; i < data.lb_3_num.length; i++) {
					if (data.lb_3_num[i] <= 1) {
						point_data.push({
							name: '机会',
							value: data.lb_3_num[i],
							xAxis: data.categoryData[i],
							yAxis: data.max_lb_num[i]
						})
					}
				}
				return point_data
			},
			get_mark_point_data_damian(data) {
				var point_data = [];
				for (var i = 0; i < data.damian_num.length; i++) {
					if (data.damian_num[i] > 0) {
						point_data.push({
							name: '风险',
							value: data.damian_num[i],
							xAxis: data.categoryData[i],
							yAxis: data.max_lb_num[i]
						})
					}
				}
				return point_data
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis[0].data[0])
						if(data_start <= Moment('2015-01-05')){
							return
						}
						let data_start_new = data_start.add(-1,'years').format("YYYY-MM-DD")
						// console.log(data_start_new)
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
					
				}
				// console.log(option)
			},
        refresh(data_start) {
            const upColor = this.colorblind ? '#E69F00' : '#ec0000'
            const downColor = this.colorblind ? '#0072B2' : '#00da3c'
            const downBorderColor = downColor
            this.line.color = [upColor, "#504f51", downBorderColor, "#504f51", "#5c74f0", "#5c74f0", "#5c74f0"]
            // this.modal = 0;
            let url_k = '/v2/api/sentiment/kline/day/'+this.modal+'?date1='
            let url = '/open/sentiment/data?date1='
            let url_zhaban = '/sentiment/market/data'
				
				if(data_start){
					url += data_start
					url_k += data_start
				}else{
					url += Moment().add(-1,'years').format('YYYY-MM-DD'); 
					url_k += Moment().add(-1,'years').format('YYYY-MM-DD'); 
				}
				let zhaban_params = {
									"date1": data_start || Moment().add(-1,'years').format('YYYY-MM-DD'),
									"with_zs": "399905"
								}
				// 同时请求K线数据、情绪数据和炸板率数据
				Promise.all([
					request_zzquant({ url: url_k }),
					request_zzquant({ url: url }),
					request_zrx({ url: url_zhaban, params: zhaban_params })
				]).then(([klineRes, sentimentRes, zhabanRes]) => {
					// 处理K线数据
					let klineData = this.splitKlineData(klineRes['data']['data']);
					// 处理情绪数据
					let splitDataItem = this.splitData(sentimentRes['data']['data']);
					// 处理炸板率数据
					let zhabanDataItem = this.splitZhabanData(zhabanRes['data']['data']);
					
					let series_data = []
					
					// 添加K线数据
					// 添加K线数据
                series_data.push({
                    name: "K",
                    type: 'candlestick',
                    data: klineData.values,
                    xAxisIndex: 0,
                    yAxisIndex: 0,
                    itemStyle: {
                        color: upColor,
                        color0: downColor,
                        borderColor: upColor,
                        borderColor0: downColor
                    },
					markPoint: {
						data: klineData.iceData,
						symbol: 'diamond',
						symbolSize: 8,
						itemStyle: {
							color: '#4682B4',
							opacity: 0.7
						},
						label: {
							show: false
						},
						
						tooltip: {
							formatter: function (param) {
								return param.name + '<br>' + (param.data.coord || '');
							}
						}
					},
					markLine: {
						data: klineData.mark_line_mon,
						symbol:'none',//去掉箭头
								lineStyle: {
									type:'dotted',
									color: "#AAA",
									normal: {
										width: 1,
										color: "#AAA",
										opacity: 0.6,
									}
								},
								
								label: {
									formatter: ""
								},
						}
					});
					
					// 添加MA3和MA5
					// series_data.push({
					// 	name: 'MA3',
					// 	data: this.calculateMAForKline(3, klineData.values),
					// 	type: 'line',
					// 	xAxisIndex: 0,
					// 	yAxisIndex: 0,
					// 	showSymbol: false,
					// 	lineStyle: {
					// 		normal: {
					// 			width: 1,
					// 			opacity: 0.7
					// 		}
					// 	}
					// });
					
					series_data.push({
						name: 'MA5',
						data: this.calculateMAForKline(5, klineData.values),
						type: 'line',
						xAxisIndex: 0,
						yAxisIndex: 0,
						showSymbol: false,
						lineStyle: {
							normal: {
								width: 1,
								opacity: 0.6
							}
						},
						symbol: 'circle',
						markLine: {
							symbol: 'none',
							lineStyle: {
								type: 'solid',
								normal: {
									width: 1,
									opacity: 0.5,
									type:'dashed',
								}
							},
							data: klineData.mark_line_day1
						}
					});
					
					// 添加最高板数据（第二个区域）
                series_data.push({
                    name: '最高板',
                    data: splitDataItem.max_lb_num,
                    type: 'line',
                    symbol: 'diamond',
                    symbolSize: 8,
                    showSymbol: true,
                    xAxisIndex: 1,
                    yAxisIndex: 1,
                    itemStyle: { color: upColor },
						markPoint: {
							symbol: 'circle',
							symbolSize: 12,
							symbolOffset: [0, 0],
							data: this.get_mark_point_data(splitDataItem),
						},
						label: {
							show: true,
							formatter: function(params) {
								return splitDataItem.max_lb_stocks[params.dataIndex];
							}
						},
						lineStyle: {
							normal: {
								width: 1,
								opacity: 1
							}
						},
                    markLine:{
                        symbol:'none',
                        lineStyle: {
                            type:'solid',
                            normal: {
                                width: 1,
                                opacity: 0.5,
                                color: upColor
                            }
                        },
                        data: splitDataItem.mark_line_day1
                    }
                });
					
					// 添加涨停板数据（第三个区域）
                series_data.push({
                    name: '涨停板',
                    data: splitDataItem.uplimit_num_m,
                    type: 'bar',
                    stack: "堆叠",
                    xAxisIndex: 2,
                    yAxisIndex: 2,
						label: {
							show: true,
							position: 'top',
							formatter: function(params) {
								return splitDataItem.uplimit_num[params.dataIndex];
							}
						},
                    itemStyle: {
                        normal: {
                            width: 1,
                            opacity: 0.8,
                            color: upColor
                        }
                    },
						markLine:{
							symbol:'none',
							lineStyle: {
								type:'solid',
								normal: {
									width: 1,
									opacity: 0.5,
								}
							},
							data: splitDataItem.mark_line_mon
						}
					});
					
                series_data.push({
                    name: '跌停板',
                    data: splitDataItem.downlimit_num_m,
                    type: 'bar',
                    stack: "堆叠",
                    xAxisIndex: 2,
                    yAxisIndex: 2,
						label: {
							show: true,
							position: 'bottom',
							formatter: function(params) {
								return splitDataItem.downlimit_num[params.dataIndex];
							}
						},
                    itemStyle: {
                        normal: {
                            width: 1,
                            opacity: 0.8,
                            color: downBorderColor
                        }
                    }
                });
                series_data.push({
                    name: '封板率',
                    data: zhabanDataItem.zb_pct.map((value, ) => {
                        // 计算封板率数据的均值
                        const average = zhabanDataItem.zb_pct.reduce((sum, val) => sum + parseFloat(val), 0) / zhabanDataItem.zb_pct.length;
                        // const average = 65;
                        const currentValue = parseFloat(value);
                        return {
                            value: value,
                            itemStyle: {
                                color: currentValue > average ? upColor : downColor,
                            }
                        };
                    }),
						type: 'line',
						symbol: 'circle',
						showSymbol: true,
						symbolSize: 8,
						xAxisIndex: 3,
						yAxisIndex: 4,
						markLine: {
							data: [{
								type: 'average',
								name: '封板率均值',
								symbol: 'circle',
								lineStyle: {
									color: '#666',
									type: 'o'
								}
							}]
						},
						lineStyle: {
							normal: {
								width: 2,
								opacity: 0.7,
								color: '#666'
							}
						},
					});
					// series_data.push({
					// 	name: '连板数',
					// 	data: zhabanDataItem.num_lb,
					// 	type: 'line',
					// 	xAxisIndex: 3,
					// 	yAxisIndex: 4,
						
					// });
					// 在refresh方法中，修改xAxis数据设置
					this.line['xAxis'] = [ { data: klineData.categoryData }, // 使用情绪数据的日期
						{ data: splitDataItem.categoryData },
						{ data: splitDataItem.categoryData },{ data: zhabanDataItem.categoryData }
					];
					this.line['series'] = series_data;
				}).catch(error => {
					console.error('数据请求失败:', error);
				});
			},
			switchModal(newModal) {
				this.modal = newModal;
				this.refresh(); // 重新加载数据
			}
		}
	}
</script>

<style scoped>
.chart-day-timing {
	width: 100% !important;
	height: 900px !important;
}

.modal-button {
	font-size: small;
	padding: 1px 5px;
	border: 1px solid #ccc;
	background: white;
	color: #333;
	transition: all 0.3s;
	cursor: pointer;
}

.modal-button:hover {
	background: #f8f9fa;
}

.modal-button.active {
	background: #7ab3ef;
	color: white;
	border-color: #007bff;
}
</style>
